import { render, staticRenderFns } from "./ConfigureServer.vue?vue&type=template&id=059867a6&"
import script from "./ConfigureServer.vue?vue&type=script&lang=js&"
export * from "./ConfigureServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports